// Mock CSV Data for The Knight Client AI

export const WORKLOAD_DATA = [
  { planNumber: "59", handleTimeAvg: 307, messagesReceived: 1153, newConversations: 596 },
  { planNumber: "1034", handleTimeAvg: 364, messagesReceived: 175, newConversations: 125 },
  { planNumber: "13011", handleTimeAvg: 163, messagesReceived: 168, newConversations: 155 },
  { planNumber: "13187", handleTimeAvg: 181, messagesReceived: 316, newConversations: 210 },
  { planNumber: "13324", handleTimeAvg: 281, messagesReceived: 231, newConversations: 159 },
  { planNumber: "14332", handleTimeAvg: 183, messagesReceived: 274, newConversations: 166 },
  { planNumber: "14334/1", handleTimeAvg: 267, messagesReceived: 596, newConversations: 432 },
  { planNumber: "14334/2", handleTimeAvg: 258, messagesReceived: 262, newConversations: 165 },
  { planNumber: "14334/3", handleTimeAvg: 223, messagesReceived: 254, newConversations: 204 },
  { planNumber: "1449", handleTimeAvg: 260, messagesReceived: 797, newConversations: 442 },
  { planNumber: "17112", handleTimeAvg: 185, messagesReceived: 130, newConversations: 67 },
  { planNumber: "1788", handleTimeAvg: 277, messagesReceived: 154, newConversations: 89 },
  { planNumber: "19641", handleTimeAvg: 212, messagesReceived: 289, newConversations: 185 },
  { planNumber: "21801T", handleTimeAvg: 304, messagesReceived: 18, newConversations: 23 },
  { planNumber: "225", handleTimeAvg: 209, messagesReceived: 666, newConversations: 580 },
  { planNumber: "23903", handleTimeAvg: 161, messagesReceived: 57, newConversations: 47 },
  { planNumber: "24159Y", handleTimeAvg: 248, messagesReceived: 131, newConversations: 121 },
  { planNumber: "246", handleTimeAvg: 247, messagesReceived: 443, newConversations: 322 },
  { planNumber: "29904", handleTimeAvg: 297, messagesReceived: 110, newConversations: 102 },
  { planNumber: "3017", handleTimeAvg: 312, messagesReceived: 905, newConversations: 569 },
  { planNumber: "30686", handleTimeAvg: 371, messagesReceived: 251, newConversations: 142 },
  { planNumber: "312", handleTimeAvg: 224, messagesReceived: 399, newConversations: 261 },
  { planNumber: "313922G", handleTimeAvg: 223, messagesReceived: 501, newConversations: 168 },
  { planNumber: "321957Q", handleTimeAvg: 212, messagesReceived: 182, newConversations: 128 },
  { planNumber: "325381X", handleTimeAvg: 286, messagesReceived: 334, newConversations: 197 },
  { planNumber: "327746W", handleTimeAvg: 230, messagesReceived: 241, newConversations: 179 },
  { planNumber: "327863S", handleTimeAvg: 265, messagesReceived: 90, newConversations: 67 },
  { planNumber: "328658N", handleTimeAvg: 246, messagesReceived: 260, newConversations: 231 },
  { planNumber: "331291P/2", handleTimeAvg: 188, messagesReceived: 669, newConversations: 402 },
  { planNumber: "332412Y-1", handleTimeAvg: 285, messagesReceived: 803, newConversations: 599 },
  { planNumber: "334479D", handleTimeAvg: 176, messagesReceived: 519, newConversations: 323 },
  { planNumber: "336126D", handleTimeAvg: 275, messagesReceived: 472, newConversations: 237 },
  { planNumber: "336310L", handleTimeAvg: 109, messagesReceived: 38, newConversations: 27 },
  { planNumber: "337357C", handleTimeAvg: 282, messagesReceived: 163, newConversations: 105 },
  { planNumber: "346694G", handleTimeAvg: 240, messagesReceived: 62, newConversations: 40 },
  { planNumber: "35088J", handleTimeAvg: 214, messagesReceived: 70, newConversations: 60 },
  { planNumber: "35488R", handleTimeAvg: 208, messagesReceived: 298, newConversations: 189 },
  { planNumber: "35848M", handleTimeAvg: 236, messagesReceived: 185, newConversations: 148 },
  { planNumber: "37154M", handleTimeAvg: 291, messagesReceived: 198, newConversations: 122 },
  { planNumber: "406495G", handleTimeAvg: 327, messagesReceived: 616, newConversations: 545 },
  { planNumber: "407137E", handleTimeAvg: 196, messagesReceived: 138, newConversations: 138 },
  { planNumber: "408036F", handleTimeAvg: 235, messagesReceived: 59, newConversations: 57 },
  { planNumber: "409115E/2", handleTimeAvg: 268, messagesReceived: 554, newConversations: 544 },
  { planNumber: "410665J", handleTimeAvg: 230, messagesReceived: 831, newConversations: 622 },
  { planNumber: "411688Q", handleTimeAvg: 293, messagesReceived: 1606, newConversations: 2037 },
  { planNumber: "419703E/2", handleTimeAvg: 364, messagesReceived: 443, newConversations: 346 },
  { planNumber: "420095T", handleTimeAvg: 224, messagesReceived: 439, newConversations: 204 },
  { planNumber: "421853V-1", handleTimeAvg: 341, messagesReceived: 591, newConversations: 403 },
  { planNumber: "428541D/15", handleTimeAvg: 288, messagesReceived: 618, newConversations: 416 },
  { planNumber: "428541D/3", handleTimeAvg: 249, messagesReceived: 644, newConversations: 323 },
  { planNumber: "429174Y", handleTimeAvg: 204, messagesReceived: 266, newConversations: 217 },
  { planNumber: "431573V/1", handleTimeAvg: 266, messagesReceived: 1531, newConversations: 744 },
  { planNumber: "432199N", handleTimeAvg: 195, messagesReceived: 168, newConversations: 132 },
  { planNumber: "432205W", handleTimeAvg: 284, messagesReceived: 673, newConversations: 534 },
  { planNumber: "434217D", handleTimeAvg: 560, messagesReceived: 117, newConversations: 81 },
  { planNumber: "437612F/1", handleTimeAvg: 199, messagesReceived: 160, newConversations: 107 },
  { planNumber: "437612F/2", handleTimeAvg: 142, messagesReceived: 130, newConversations: 72 },
  { planNumber: "437683F", handleTimeAvg: 204, messagesReceived: 148, newConversations: 101 },
  { planNumber: "438603B", handleTimeAvg: 241, messagesReceived: 396, newConversations: 280 },
  { planNumber: "438902Q", handleTimeAvg: 280, messagesReceived: 636, newConversations: 449 },
  { planNumber: "443025M", handleTimeAvg: 150, messagesReceived: 43, newConversations: 34 },
  { planNumber: "444563B", handleTimeAvg: 172, messagesReceived: 60, newConversations: 61 },
  { planNumber: "445059H", handleTimeAvg: 253, messagesReceived: 742, newConversations: 375 },
  { planNumber: "445231X", handleTimeAvg: 260, messagesReceived: 59, newConversations: 42 },
  { planNumber: "446158A", handleTimeAvg: 221, messagesReceived: 547, newConversations: 269 },
  { planNumber: "447151K", handleTimeAvg: 145, messagesReceived: 145, newConversations: 74 },
  { planNumber: "501388C/1", handleTimeAvg: 405, messagesReceived: 1575, newConversations: 924 },
  { planNumber: "504017Y/1", handleTimeAvg: 353, messagesReceived: 163, newConversations: 126 },
  { planNumber: "507443P/2", handleTimeAvg: 387, messagesReceived: 160, newConversations: 118 },
  { planNumber: "5097", handleTimeAvg: 249, messagesReceived: 63, newConversations: 41 },
  { planNumber: "511490F/1", handleTimeAvg: 236, messagesReceived: 425, newConversations: 248 },
  { planNumber: "518573N", handleTimeAvg: 299, messagesReceived: 446, newConversations: 299 },
  { planNumber: "520422X", handleTimeAvg: 280, messagesReceived: 260, newConversations: 187 },
  { planNumber: "526692J", handleTimeAvg: 274, messagesReceived: 244, newConversations: 125 },
  { planNumber: "527183B", handleTimeAvg: 367, messagesReceived: 169, newConversations: 119 }
];

export const COMPLIANCE_DATA = [
  { planNumber: "59", manager: "Alice Rogers-Ross", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "1034", manager: "June Lim", status: "Pending", overdueCount: 0, warningCount: 0 },
  { planNumber: "13011", manager: "Yi Ping Shak", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "13187", manager: "Yi Ping Shak", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "13324", manager: "Sean Ewinger", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "14332", manager: "Abi Munshi", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "14334/1", manager: "Rama Murugesu", status: "Overdue", overdueCount: 2, warningCount: 2 },
  { planNumber: "14334/2", manager: "Rama Murugesu", status: "Overdue", overdueCount: 2, warningCount: 2 },
  { planNumber: "14334/3", manager: "Rama Murugesu", status: "Warning", overdueCount: 0, warningCount: 2 },
  { planNumber: "1449", manager: "Alice Rogers-Ross", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "17112", manager: "June Lim", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "1788", manager: "Kasey Lee", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "19641", manager: "June Lim", status: "Overdue", overdueCount: 3, warningCount: 0 },
  { planNumber: "21801T", manager: "June Lim", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "225", manager: "Nathalie Appere", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "23903", manager: "June Lim", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "24159Y", manager: "Alice Rogers-Ross", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "246", manager: "Sean Ewinger", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "29904", manager: "Yi Ping Shak", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "3017", manager: "Sean Ewinger", status: "Overdue", overdueCount: 1, warningCount: 2 },
  { planNumber: "30686", manager: "Stavros Loizides", status: "Overdue", overdueCount: 3, warningCount: 1 },
  { planNumber: "312", manager: "Abi Munshi", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "313922G", manager: "Kasey Lee", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "321957Q", manager: "June Lim", status: "Overdue", overdueCount: 3, warningCount: 0 },
  { planNumber: "325381X", manager: "Stavros Loizides", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "327746W", manager: "Yi Ping Shak", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "327863S", manager: "Abi Munshi", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "328658N", manager: "Sean Ewinger", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "331291P/2", manager: "Alice Rogers-Ross", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "332412Y-1", manager: "Rama Murugesu", status: "Overdue", overdueCount: 3, warningCount: 0 },
  { planNumber: "334479D", manager: "Alice Rogers-Ross", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "336126D", manager: "Stavros Loizides", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "336310L", manager: "Abi Munshi", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "337357C", manager: "Sean Ewinger", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "346694G", manager: "June Lim", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "35088J", manager: "Sean Ewinger", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "35488R", manager: "Kasey Lee", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "35848M", manager: "Sean Ewinger", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "37154M", manager: "Sean Ewinger", status: "Overdue", overdueCount: 1, warningCount: 2 },
  { planNumber: "406495G", manager: "Achini Fernando", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "407137E", manager: "Nathalie Appere", status: "Overdue", overdueCount: 1, warningCount: 2 },
  { planNumber: "408036F", manager: "Nathalie Appere", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "409115E/2", manager: "Daniel Rodoni", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "410665J", manager: "Abi Munshi", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "411688Q", manager: "Achini Fernando", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "419703E/2", manager: "Rama Murugesu", status: "Overdue", overdueCount: 3, warningCount: 0 },
  { planNumber: "420095T", manager: "Stavros Loizides", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "421853V-1", manager: "Anand Bala", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "428541D/15", manager: "Achini Fernando", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "428541D/3", manager: "Jade Camilleri", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "429174Y", manager: "Nathalie Appere", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "431573V/1", manager: "Darren Levison", status: "Overdue", overdueCount: 3, warningCount: 1 },
  { planNumber: "432199N", manager: "Nathalie Appere", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "432205W", manager: "Rama Murugesu", status: "Overdue", overdueCount: 3, warningCount: 0 },
  { planNumber: "434217D", manager: "Kasey Lee", status: "Warning", overdueCount: 0, warningCount: 2 },
  { planNumber: "437612F/1", manager: "June Lim", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "437612F/2", manager: "June Lim", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "437683F", manager: "Alice Rogers-Ross", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "438603B", manager: "Kasey Lee", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "438902Q", manager: "Darren Levison", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "443025M", manager: "June Lim", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "444563B", manager: "June Lim", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "445059H", manager: "Sean Ewinger", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "445231X", manager: "June Lim", status: "Overdue", overdueCount: 1, warningCount: 0 },
  { planNumber: "446158A", manager: "Jade Camilleri", status: "Overdue", overdueCount: 2, warningCount: 0 },
  { planNumber: "447151K", manager: "Kasey Lee", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "501388C/1", manager: "Darren Levison", status: "Overdue", overdueCount: 3, warningCount: 1 },
  { planNumber: "504017Y/1", manager: "Rama Murugesu", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "507443P/2", manager: "Jade Camilleri", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "5097", manager: "June Lim", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "511490F/1", manager: "Rama Murugesu", status: "Overdue", overdueCount: 2, warningCount: 1 },
  { planNumber: "518573N", manager: "Mikaela Williams", status: "Pending", overdueCount: 0, warningCount: 0 },
  { planNumber: "520422X", manager: "Sean Ewinger", status: "Warning", overdueCount: 0, warningCount: 1 },
  { planNumber: "526692J", manager: "Kasey Lee", status: "Overdue", overdueCount: 1, warningCount: 1 },
  { planNumber: "527183B", manager: "Nathalie Appere", status: "Warning", overdueCount: 0, warningCount: 1 }
];

export const REVENUE_DATA = [
  { planNumber: "59", managementFees: 12000, totalRevenue: 15000 },
  { planNumber: "1034", managementFees: 11000, totalRevenue: 14000 },
  { planNumber: "13011", managementFees: 9000, totalRevenue: 12000 },
  { planNumber: "13187", managementFees: 10500, totalRevenue: 13000 },
  { planNumber: "13324", managementFees: 14000, totalRevenue: 16000 },
  { planNumber: "14332", managementFees: 8500, totalRevenue: 10000 },
  { planNumber: "14334/1", managementFees: 15000, totalRevenue: 18000 },
  { planNumber: "14334/2", managementFees: 12000, totalRevenue: 14500 },
  { planNumber: "14334/3", managementFees: 11000, totalRevenue: 13500 },
  { planNumber: "1449", managementFees: 22000, totalRevenue: 28000 },
  { planNumber: "17112", managementFees: 8000, totalRevenue: 9500 },
  { planNumber: "1788", managementFees: 7500, totalRevenue: 8800 },
  { planNumber: "19641", managementFees: 13000, totalRevenue: 15500 },
  { planNumber: "21801T", managementFees: 5000, totalRevenue: 6000 },
  { planNumber: "225", managementFees: 35000, totalRevenue: 42000 },
  { planNumber: "23903", managementFees: 7000, totalRevenue: 8200 },
  { planNumber: "24159Y", managementFees: 6000, totalRevenue: 7200 },
  { planNumber: "246", managementFees: 12500, totalRevenue: 14800 },
  { planNumber: "29904", managementFees: 5500, totalRevenue: 6800 },
  { planNumber: "3017", managementFees: 18000, totalRevenue: 21000 },
  { planNumber: "30686", managementFees: 9000, totalRevenue: 11000 },
  { planNumber: "312", managementFees: 12000, totalRevenue: 14500 },
  { planNumber: "313922G", managementFees: 16000, totalRevenue: 19000 },
  { planNumber: "321957Q", managementFees: 8500, totalRevenue: 10500 },
  { planNumber: "325381X", managementFees: 11000, totalRevenue: 13000 },
  { planNumber: "327746W", managementFees: 7800, totalRevenue: 9200 },
  { planNumber: "327863S", managementFees: 4000, totalRevenue: 5000 },
  { planNumber: "328658N", managementFees: 9500, totalRevenue: 11500 },
  { planNumber: "331291P/2", managementFees: 25000, totalRevenue: 29000 },
  { planNumber: "332412Y-1", managementFees: 28000, totalRevenue: 32000 },
  { planNumber: "334479D", managementFees: 17000, totalRevenue: 20000 },
  { planNumber: "336126D", managementFees: 15000, totalRevenue: 18500 },
  { planNumber: "336310L", managementFees: 3000, totalRevenue: 3800 },
  { planNumber: "337357C", managementFees: 6000, totalRevenue: 7500 },
  { planNumber: "346694G", managementFees: 4500, totalRevenue: 5500 },
  { planNumber: "35088J", managementFees: 3800, totalRevenue: 4800 },
  { planNumber: "35488R", managementFees: 10000, totalRevenue: 12000 },
  { planNumber: "35848M", managementFees: 7000, totalRevenue: 8500 },
  { planNumber: "37154M", managementFees: 6500, totalRevenue: 8000 },
  { planNumber: "406495G", managementFees: 21000, totalRevenue: 24500 },
  { planNumber: "407137E", managementFees: 12500, totalRevenue: 14500 },
  { planNumber: "408036F", managementFees: 7000, totalRevenue: 8500 },
  { planNumber: "409115E/2", managementFees: 19000, totalRevenue: 22000 },
  { planNumber: "410665J", managementFees: 24000, totalRevenue: 28500 },
  { planNumber: "411688Q", managementFees: 65000, totalRevenue: 75000 },
  { planNumber: "419703E/2", managementFees: 14000, totalRevenue: 16500 },
  { planNumber: "420095T", managementFees: 13500, totalRevenue: 16000 },
  { planNumber: "421853V-1", managementFees: 18000, totalRevenue: 21500 },
  { planNumber: "428541D/15", managementFees: 17500, totalRevenue: 20500 },
  { planNumber: "428541D/3", managementFees: 19000, totalRevenue: 22500 },
  { planNumber: "429174Y", managementFees: 16500, totalRevenue: 19500 },
  { planNumber: "431573V/1", managementFees: 45000, totalRevenue: 52000 },
  { planNumber: "432199N", managementFees: 9000, totalRevenue: 11000 },
  { planNumber: "432205W", managementFees: 23000, totalRevenue: 27000 },
  { planNumber: "434217D", managementFees: 6000, totalRevenue: 7500 },
  { planNumber: "437612F/1", managementFees: 8000, totalRevenue: 9500 },
  { planNumber: "437612F/2", managementFees: 6500, totalRevenue: 8000 },
  { planNumber: "437683F", managementFees: 5500, totalRevenue: 6800 },
  { planNumber: "438603B", managementFees: 14500, totalRevenue: 17000 },
  { planNumber: "438902Q", managementFees: 32000, totalRevenue: 38000 },
  { planNumber: "443025M", managementFees: 3000, totalRevenue: 3800 },
  { planNumber: "444563B", managementFees: 5000, totalRevenue: 6200 },
  { planNumber: "445059H", managementFees: 13500, totalRevenue: 16000 },
  { planNumber: "445231X", managementFees: 3500, totalRevenue: 4500 },
  { planNumber: "446158A", managementFees: 17000, totalRevenue: 20000 },
  { planNumber: "447151K", managementFees: 5200, totalRevenue: 6500 },
  { planNumber: "501388C/1", managementFees: 42000, totalRevenue: 49000 },
  { planNumber: "504017Y/1", managementFees: 7500, totalRevenue: 9000 },
  { planNumber: "507443P/2", managementFees: 6800, totalRevenue: 8200 },
  { planNumber: "5097", managementFees: 3200, totalRevenue: 4000 },
  { planNumber: "511490F/1", managementFees: 11500, totalRevenue: 13500 },
  { planNumber: "518573N", managementFees: 12000, totalRevenue: 14200 },
  { planNumber: "520422X", managementFees: 7800, totalRevenue: 9500 },
  { planNumber: "526692J", managementFees: 8200, totalRevenue: 9800 },
  { planNumber: "527183B", managementFees: 6500, totalRevenue: 8000 }
];

export const NPS_DATA = [
  { planNumber: "59", teamLeader: "TL A", manager: "Mgr A", score: 10, comment: "Excellent service" },
  { planNumber: "1034", teamLeader: "TL B", manager: "Mgr B", score: 8, comment: "Good response time" },
  { planNumber: "13011", teamLeader: "TL A", manager: "Mgr A", score: 9, comment: "Very happy" },
  { planNumber: "13187", teamLeader: "TL C", manager: "Mgr C", score: 5, comment: "Slow to react" },
  { planNumber: "13324", teamLeader: "TL B", manager: "Mgr D", score: 7, comment: "Adequate" },
  { planNumber: "14332", teamLeader: "TL A", manager: "Mgr B", score: 3, comment: "Issues unresolved" },
  { planNumber: "14334/1", teamLeader: "TL C", manager: "Mgr E", score: 9, comment: "Great team" },
  { planNumber: "14334/2", teamLeader: "TL C", manager: "Mgr E", score: 8, comment: "" },
  { planNumber: "14334/3", teamLeader: "TL C", manager: "Mgr E", score: 10, comment: "Perfect" },
  { planNumber: "1449", teamLeader: "TL A", manager: "Mgr A", score: 6, comment: "Could be better" },
  { planNumber: "17112", teamLeader: "TL B", manager: "Mgr F", score: 9, comment: "Happy" },
  { planNumber: "1788", teamLeader: "TL A", manager: "Mgr A", score: 4, comment: "Not responsive" },
  { planNumber: "19641", teamLeader: "TL C", manager: "Mgr C", score: 8, comment: "Good job" },
  { planNumber: "21801T", teamLeader: "TL B", manager: "Mgr B", score: 7, comment: "Okay" },
  { planNumber: "225", teamLeader: "TL D", manager: "Mgr G", score: 10, comment: "Amazing work" },
  { planNumber: "23903", teamLeader: "TL A", manager: "Mgr A", score: 2, comment: "Terrible" },
  { planNumber: "24159Y", teamLeader: "TL A", manager: "Mgr A", score: 9, comment: "Good" },
  { planNumber: "246", teamLeader: "TL B", manager: "Mgr D", score: 8, comment: "Solid performance" },
  { planNumber: "29904", teamLeader: "TL C", manager: "Mgr C", score: 5, comment: "Average" },
  { planNumber: "3017", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Very professional" },
  { planNumber: "30686", teamLeader: "TL A", manager: "Mgr H", score: 3, comment: "Poor communication" },
  { planNumber: "312", teamLeader: "TL B", manager: "Mgr B", score: 10, comment: "Best manager" },
  { planNumber: "313922G", teamLeader: "TL C", manager: "Mgr E", score: 9, comment: "Great" },
  { planNumber: "321957Q", teamLeader: "TL A", manager: "Mgr A", score: 8, comment: "Good" },
  { planNumber: "325381X", teamLeader: "TL D", manager: "Mgr H", score: 7, comment: "Fine" },
  { planNumber: "327746W", teamLeader: "TL B", manager: "Mgr B", score: 6, comment: "Slow" },
  { planNumber: "327863S", teamLeader: "TL A", manager: "Mgr B", score: 9, comment: "Excellent" },
  { planNumber: "328658N", teamLeader: "TL C", manager: "Mgr E", score: 10, comment: "Top notch" },
  { planNumber: "331291P/2", teamLeader: "TL A", manager: "Mgr A", score: 4, comment: "Unhappy with fees" },
  { planNumber: "332412Y-1", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Very good" },
  { planNumber: "334479D", teamLeader: "TL B", manager: "Mgr D", score: 8, comment: "Reliable" },
  { planNumber: "336126D", teamLeader: "TL C", manager: "Mgr H", score: 2, comment: "Disappointed" },
  { planNumber: "336310L", teamLeader: "TL A", manager: "Mgr B", score: 9, comment: "Nice work" },
  { planNumber: "337357C", teamLeader: "TL B", manager: "Mgr B", score: 10, comment: "Fantastic" },
  { planNumber: "346694G", teamLeader: "TL C", manager: "Mgr C", score: 7, comment: "Okay service" },
  { planNumber: "35088J", teamLeader: "TL D", manager: "Mgr H", score: 8, comment: "Good" },
  { planNumber: "35488R", teamLeader: "TL A", manager: "Mgr F", score: 9, comment: "Very satisfied" },
  { planNumber: "35848M", teamLeader: "TL B", manager: "Mgr D", score: 5, comment: "Needs improvement" },
  { planNumber: "37154M", teamLeader: "TL C", manager: "Mgr E", score: 10, comment: "Great" },
  { planNumber: "406495G", teamLeader: "TL D", manager: "Mgr G", score: 6, comment: "Average" },
  { planNumber: "407137E", teamLeader: "TL A", manager: "Mgr H", score: 9, comment: "Good" },
  { planNumber: "408036F", teamLeader: "TL B", manager: "Mgr B", score: 8, comment: "Happy" },
  { planNumber: "409115E/2", teamLeader: "TL C", manager: "Mgr C", score: 4, comment: "Issues with maintenance" },
  { planNumber: "410665J", teamLeader: "TL A", manager: "Mgr B", score: 10, comment: "Love the team" },
  { planNumber: "411688Q", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Great management" },
  { planNumber: "419703E/2", teamLeader: "TL B", manager: "Mgr D", score: 7, comment: "Okay" },
  { planNumber: "420095T", teamLeader: "TL C", manager: "Mgr H", score: 8, comment: "Good" },
  { planNumber: "421853V-1", teamLeader: "TL A", manager: "Mgr A", score: 3, comment: "Not happy" },
  { planNumber: "428541D/15", teamLeader: "TL B", manager: "Mgr B", score: 9, comment: "Excellent" },
  { planNumber: "428541D/3", teamLeader: "TL C", manager: "Mgr E", score: 10, comment: "Perfect" },
  { planNumber: "429174Y", teamLeader: "TL D", manager: "Mgr G", score: 5, comment: "Slow response" },
  { planNumber: "431573V/1", teamLeader: "TL A", manager: "Mgr H", score: 9, comment: "Good work" },
  { planNumber: "432199N", teamLeader: "TL B", manager: "Mgr D", score: 8, comment: "Solid" },
  { planNumber: "432205W", teamLeader: "TL C", manager: "Mgr C", score: 2, comment: "Bad experience" },
  { planNumber: "434217D", teamLeader: "TL A", manager: "Mgr B", score: 9, comment: "Good" },
  { planNumber: "437612F/1", teamLeader: "TL B", manager: "Mgr F", score: 10, comment: "Excellent" },
  { planNumber: "437612F/2", teamLeader: "TL C", manager: "Mgr E", score: 7, comment: "Okay" },
  { planNumber: "437683F", teamLeader: "TL A", manager: "Mgr A", score: 8, comment: "Good" },
  { planNumber: "438603B", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Very happy" },
  { planNumber: "438902Q", teamLeader: "TL B", manager: "Mgr D", score: 4, comment: "Could improve" },
  { planNumber: "443025M", teamLeader: "TL C", manager: "Mgr H", score: 10, comment: "Great" },
  { planNumber: "444563B", teamLeader: "TL A", manager: "Mgr B", score: 9, comment: "Good" },
  { planNumber: "445059H", teamLeader: "TL B", manager: "Mgr F", score: 6, comment: "Average" },
  { planNumber: "445231X", teamLeader: "TL C", manager: "Mgr C", score: 8, comment: "Good" },
  { planNumber: "446158A", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Happy" },
  { planNumber: "447151K", teamLeader: "TL A", manager: "Mgr A", score: 10, comment: "Excellent" },
  { planNumber: "501388C/1", teamLeader: "TL B", manager: "Mgr D", score: 3, comment: "Poor service" },
  { planNumber: "504017Y/1", teamLeader: "TL C", manager: "Mgr E", score: 9, comment: "Good" },
  { planNumber: "507443P/2", teamLeader: "TL A", manager: "Mgr H", score: 8, comment: "Nice" },
  { planNumber: "5097", teamLeader: "TL B", manager: "Mgr B", score: 7, comment: "Okay" },
  { planNumber: "511490F/1", teamLeader: "TL C", manager: "Mgr C", score: 10, comment: "Great" },
  { planNumber: "518573N", teamLeader: "TL D", manager: "Mgr G", score: 9, comment: "Good" },
  { planNumber: "520422X", teamLeader: "TL A", manager: "Mgr A", score: 5, comment: "Slow" },
  { planNumber: "526692J", teamLeader: "TL B", manager: "Mgr F", score: 8, comment: "Good" },
  { planNumber: "527183B", teamLeader: "TL C", manager: "Mgr E", score: 9, comment: "Very good" }
];

// Persona definitions - Cohort system based on Gross Margin Health & Engagement Balance
export const PERSONA_INFO = {
  'Model Clients': { 
    color: '#10b981', 
    description: 'Excellent gross margin (>50%) with low engagement cost. The ideal client profile to replicate.',
    short: 'Model',
    criteria: 'Gross Margin >50%, Engagement <30% of revenue',
    action: 'Protect & Replicate',
    recommendation: 'Use as template for new client onboarding. Maintain current service levels.'
  },
  'Stable Performers': { 
    color: '#3b82f6', 
    description: 'Good gross margin (20-50%) with balanced engagement. Reliable contributors.',
    short: 'Stable',
    criteria: 'Gross Margin 20-50%, Engagement <50% of revenue',
    action: 'Maintain & Monitor',
    recommendation: 'Continue current approach. Look for efficiency gains to improve gross margins.'
  },
  'Premium Service': { 
    color: '#8b5cf6', 
    description: 'Profitable but with high service demands. Worth the investment.',
    short: 'Premium',
    criteria: 'Gross Margin >20%, High engagement relative to revenue',
    action: 'Evaluate Service Model',
    recommendation: 'Consider premium fee structure or service optimization. May be complex properties.'
  },
  'Scale Up': { 
    color: '#06b6d4', 
    description: 'Low revenue but profitable. Growth opportunity through upselling.',
    short: 'Scale Up',
    criteria: 'Gross Margin 0-20%, Revenue below median',
    action: 'Growth Focus',
    recommendation: 'Target for fee reviews, additional services, or portfolio expansion.'
  },
  'Optimize': { 
    color: '#f59e0b', 
    description: 'High revenue with thin gross margins. Efficiency improvements needed.',
    short: 'Optimize',
    criteria: 'Gross Margin 0-20%, Revenue above median',
    action: 'Improve Efficiency',
    recommendation: 'Review communication channels, meeting frequency, and process automation.'
  },
  'Turnaround': { 
    color: '#f97316', 
    description: 'High revenue but unprofitable. Service model needs restructuring.',
    short: 'Turnaround',
    criteria: 'Gross Margin <0%, Revenue above median',
    action: 'Restructure Required',
    recommendation: 'Fee increase conversation, service level review, or dedicated account management.'
  },
  'At Risk': { 
    color: '#f43f5e', 
    description: 'Low revenue, unprofitable, but manageable engagement. Needs attention.',
    short: 'At Risk',
    criteria: 'Gross Margin <0%, Low engagement, Revenue below median',
    action: 'Review Viability',
    recommendation: 'Assess strategic value. Consider fee adjustment or exit if no improvement path.'
  },
  'Critical Review': { 
    color: '#ef4444', 
    description: 'Unprofitable with high demands. Immediate intervention required.',
    short: 'Critical',
    criteria: 'Gross Margin <0%, High message volume, Low revenue',
    action: 'Immediate Action',
    recommendation: 'Urgent meeting with client. Either restructure relationship or plan exit.'
  },
  'Unknown': { 
    color: '#94a3b8', 
    description: 'Insufficient data for classification.',
    short: 'Unknown',
    criteria: 'Missing data',
    action: 'Data Collection',
    recommendation: 'Ensure all data sources are properly mapped for this client.'
  },
};

// Cohort movement recommendations - how to progress clients to better cohorts
export const COHORT_PROGRESSION = {
  'Critical Review': {
    target: 'At Risk',
    steps: ['Reduce message volume by 50%', 'Implement self-service portal', 'Set communication boundaries']
  },
  'At Risk': {
    target: 'Scale Up',
    steps: ['Fee review conversation', 'Identify upsell opportunities', 'Improve service efficiency']
  },
  'Turnaround': {
    target: 'Optimize',
    steps: ['Negotiate fee increase', 'Restructure meeting cadence', 'Automate routine communications']
  },
  'Optimize': {
    target: 'Stable Performers',
    steps: ['Reduce meeting frequency', 'Implement batch communications', 'Standardize processes']
  },
  'Scale Up': {
    target: 'Stable Performers',
    steps: ['Add value-added services', 'Fee increase with enhanced scope', 'Portfolio growth']
  },
  'Premium Service': {
    target: 'Model Clients',
    steps: ['Review service complexity', 'Premium pricing consideration', 'Process optimization']
  },
  'Stable Performers': {
    target: 'Model Clients',
    steps: ['Reduce engagement touchpoints', 'Client self-service adoption', 'Efficiency automation']
  },
  'Model Clients': {
    target: null,
    steps: ['Maintain current approach', 'Use as benchmark for other clients', 'Protect relationship']
  }
};
